import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Grid, Box, CircularProgress } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import HeaderInfo from "../../waybee-ui/HeaderInfo/HeaderInfo";
import Group from "../../waybee-ui/Group";
import Divider from "../../waybee-ui/Divider";
import BackButton from "../../components/BackButton";
import CollapseSubGroup from "../../waybee-ui/CollapseSubGroup";
import MoreInfo from "./components/MoreInfo";
import MedicalInfo from "./components/MedicalInfo";

import StudentService from "../../services/StudentService";
import { Can } from "../../acl/can";

const HeaderGrid = styled(Grid)`
  margin-bottom: -20px;
`;

const HeaderGroup = styled(Group)`
  padding-bottom: 0;
`;

const StudentNotes = ({ match }) => {
  const { t } = useTranslation();
  const { studentId } = match.params;
  const [student, setStudent] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    StudentService.getStudentById(studentId).then(response => {
      setStudent(response);
      setLoading(false);
    });
  }, [studentId]);

  return (
    <>
      {loading ? (
        <Box p={6} textAlign="center">
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <BackButton to={`/student/${studentId}`} />
          <HeaderGrid item xs={12}>
            <HeaderGroup>
              <Box mb={2}>
                <HeaderInfo
                  name={student.name}
                  info={t("student.raInfo", { ra: student.ra })}
                  photo={student.photo}
                />
              </Box>
              <Divider />
            </HeaderGroup>
          </HeaderGrid>
          <Grid item xs={12}>
            <Can I="use module" a="studentMedicalInfo">
              <CollapseSubGroup title={t("student.notes.medical")}>
                <MedicalInfo />
              </CollapseSubGroup>
            </Can>
            <CollapseSubGroup title={t("student.notes.more")}>
              <MoreInfo obs={student.obs} />
            </CollapseSubGroup>
          </Grid>
        </Grid>
      )}
    </>
  );
};

StudentNotes.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.objectOf(PropTypes.string)
  }).isRequired
};
export default withRouter(StudentNotes);
